import { render, staticRenderFns } from "./CommonTreeviewConfigList copy.vue?vue&type=template&id=463e613a&scoped=true&"
import script from "./CommonTreeviewConfigList copy.vue?vue&type=script&lang=js&"
export * from "./CommonTreeviewConfigList copy.vue?vue&type=script&lang=js&"
import style0 from "./CommonTreeviewConfigList copy.vue?vue&type=style&index=0&id=463e613a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e613a",
  null
  
)

export default component.exports